
import {
  Component,
  Vue,
  Inject,
  Prop,
  Watch,
  Ref
} from "vue-property-decorator";

import api from "@/api";
import { SwiperDto } from "@/api/appService";
import { ElForm } from "element-ui/types/form";

@Component({ name: "EditAdSwiper" })
export default class EditAdSwiper extends Vue {
  @Ref() readonly dataForm!: ElForm;

  @Watch("show")
  async onShowChange(value: boolean) {
    if (value) {
      await api.swiper.getForEdit({ id: this.form!.id }).then(res => {
        this.form = res.data!;
      });
    } else {
      this.form = { ...this.defaultData };
    }

    this.$nextTick(() => {
      this.dataForm.clearValidate();
    });
  }

  groups = [
    {
      value: 0,
      label: "门店首页"
    }
  ];

  options = [
    {
      value: 0,
      label: "无操作"
    },
    {
      value: 1,
      label: "小程序页面跳转"
    }
  ];

  defaultData: SwiperDto = {
    groupId: undefined,
    /**  */
    swiperType: undefined,
    /**  */
    imagePath: undefined,
    /**  */
    title: undefined,
    /**  */
    url: undefined,

    id: 0
  };

  show = false;

  form: SwiperDto = { ...this.defaultData };

  async save() {
    console.log(this.form);
    (this.$refs.dataForm as any).validate(async (valid: boolean) => {
      if (valid) {
        if (this.form!.id) {
          await api.swiper.update({ body: this.form });
        } else {
          await api.swiper.create({ body: this.form });
        }
        this.show = false;
        this.$message.success("更新成功");
        this.$emit("onSave");
      }
    });
  }

  cancel() {
    this.show = false;
  }

  async handleAvatarSuccess(res: any, file: any) {
    console.log(res);
    if (res.success) {
      this.form.imagePath = res.result;
    }
  }

  async beforeAvatarUpload() {}

  roleRule = {
    groupId: [
      {
        required: true,
        message: "必填",
        trigger: "blur"
      }
    ],
    swiperType: [
      {
        required: true,
        message: "必填",
        trigger: "blur"
      }
    ],
    imagePath: [
      {
        required: true,
        message: "必填",
        trigger: "blur"
      }
    ],
    title: [
      {
        required: true,
        message: "必填",
        trigger: "blur"
      }
    ]
  };
}
